<section >
    <h2 class="text-left text-white px-5 mt-5">Rentabilidad proyecto {{title}}</h2>

    <div class="container-fluid px-5">
        <div class="row text-white mt-5">
            <div class="col-8 ">
                <form action="" 
                method="post"
                (submit)="formSumbmit()"
                [formGroup]="dates"
                class="d-flex justify-content-around">
                    <div>
                        <label for="formControlInput" class="form-label me-4">Fecha inicio</label>
                        <input required id="start_date" type="date" class="custom-outline-input  date" formControlName="start_date">
                    </div>
                    <div>
                        <label for="formControlInput" class="form-label me-4">Fecha termino</label>
                        <input required id="end_date" type="date" class="custom-outline-input  date" formControlName="end_date">
                    </div>
                    <div class="">
                        <button type="submit" class="form-control btn btn-outline-light" ><i class="fa-solid fa-magnifying-glass"></i>Buscar</button>
                     </div>
            </form>
            </div>
            <div class="col-4 d-flex justify-content-end">
                <button
                class="badge rounded-pill btn btn-outline-light d-flex align-items-center "
                [routerLink]="['/pdg/project/list']"
              >
                <i
                  class="fa-solid fa-right-from-bracket m-2 fs-6"
                  aria-hidden="true"
                ></i>
                <span class="m-2 fs-6">Volver</span>
              </button>            </div>
        </div>
        <br>
        <div class="backgroundTable card">
            <div class="card-header d-flex justify-content-around text-center">
                <div>
                    <h4 class="text-white">Rentabilidad real</h4>
                    <span class="badge rounded-pill text-bg-success my-1" style="font-size: 16px;">{{costEffecctiveness.margenRentabilidad}}%</span>
                </div>
                <div>
                    <h4 class="text-white">Rentabilidad Estimada</h4>
                    <span class="badge rounded-pill text-bg-success my-1" style="font-size: 16px;">{{costEffecctiveness.margenRentabilidadEstimada}}%</span>
                    
                </div>
            </div>
                <div  class=" text-white text-center componente-importantes componente-importantes-from-popup" >
                    <h2 class="text-white px-5 mt-5">Hitos de pago</h2>
                    <div class="">
                            <div class="chart-container p-3" style="position: relative;">
                              <canvas id="chart-line" ></canvas>
                            </div>
                    </div>
                          
                </div>
                



        </div>

        <div class="row d-flex justify-content-around text-center pt-4">
            <div class="col-12 col-md-4 pt-3">
                <div class="backgroundTable">
                    <h5 class="text-white  p-2">Valores en CLP</h5>
                    <div class="componente-importantes componente-importantes-from-popup p-2">
                    <br>
                    <div class="d-flex justify-content-around text-white pt-3">
                        <span>Total Pagos</span>
                        <span>Costo estimado</span>
                        <span>Costo Real</span>
                    </div>
                    <div class="d-flex justify-content-around text-white">
                        <span class="text-white">{{costEffecctiveness.totalPayCLP}}</span>
                        <span class="text-white">{{costEffecctiveness.totalEstimateCLP}}</span>
                        <span class="text-white">{{costEffecctiveness.totalRealCLP}}</span>
                    </div>
                </div>
                </div>
            </div>

            <div class="col-12 col-md-4 pt-3">
                <div class="backgroundTable">

                    <h5 class="text-white  p-2">Valores en USD</h5>

                    <div class="componente-importantes componente-importantes-from-popup p-2">
                    <span class="text-white">Valor Hoy: ${{costEffecctiveness.usd}}</span>
                    <div class="d-flex justify-content-around text-white pt-3">
                        <span>Total Pagos</span>
                        <span>Costo estimado</span>
                        <span>Costo Real</span>
                    </div>
                    <div class="d-flex justify-content-around text-white">
                        <span class="text-white">{{costEffecctiveness.totalPayUSD}}</span>
                        <span class="text-white">{{costEffecctiveness.totalEstimateUSD}}</span>
                        <span class="text-white">{{costEffecctiveness.totalRealUSD}}</span>
                    </div>
                </div>
                </div>
                
            </div>

            <div class="col-12 col-md-4 pt-3">
                <div class="backgroundTable">
                    <h5 class="text-white p-2">Valores en UF</h5>
                    <div class="componente-importantes componente-importantes-from-popup p-2">

                    
                    <span class="text-white ">Valor Hoy: ${{costEffecctiveness.uf}}</span>
                    <div class="d-flex justify-content-around text-white pt-3">
                        <span>Total Pagos</span>
                        <span>Costo estimado</span>
                        <span>Costo Real</span>
                    </div>
                    <div class="d-flex justify-content-around text-white ">
                        <span class="text-white">{{costEffecctiveness.totalPayUF}}</span>
                        <span class="text-white">{{costEffecctiveness.totalEstimateUF}}</span>
                        <span class="text-white">{{costEffecctiveness.totalRealUF}}</span>
                    </div>
                </div>
                </div>
                
            </div>
        </div>

        <div class="row mt-5">

            <div class="col-12 col-xl-12 align-items-stretch">
                <div class="backgroundTable text-white">

                    <div class="card-body text-center">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                            class="componente-importantes componente-importantes-from-popup text-center">
                            <ng-container *ngIf="listInfoAsign.length == 0">
                                <div class="text-center text-white">
                                    <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                                    <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="listInfoAsign.length != 0">
                                <thead>
                                    <tr>
                                        <th class="text-center">Usuario</th>
                                        <th class="text-center">Cargo</th>
                                        <th class="text-center">Meses en la asignacion</th>
                                        <th class="text-center">Costo rol</th>
                                        <th class="text-center">Costo real de Asignado</th>
                                        <th class="text-center">Coto Total Estimado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of listInfoAsign">
                                        <td>
                                            {{item.cargo}}
                                        </td>
                                        <td>
                                            {{item.name}}
                                        </td>
                                        <td>
                                            {{item.percentage}}
                                        </td>
                                        <td>
                                            {{item.realCost}}
                                        </td>
                                        <td>
                                            {{item.realCostAsig}}
                                        </td>
                                        <td>
                                            {{item.realCostTotal}}
                                        </td>
                                    </tr>
                                </tbody>

                            </ng-container>
                        </table>

                    </div>
                </div>
            </div>
        </div>


    </div>

</section>